import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * An agent's profile picture, falling back to their initials when there is none or it fails to load.
 * Decorative by default, because the agent's name is shown next to it.
 */
@Component({
  selector: 'app-agent-avatar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <img *ngIf="url && !failed; else initials" [src]="url" alt=""
      class="object-cover shrink-0" [ngClass]="[sizeClass, shapeClass]"
      (error)="failed = true" loading="lazy" />
    <ng-template #initials>
      <div class="shrink-0 bg-gradient-to-tr from-green-500 to-teal-400 text-white flex items-center justify-center font-bold"
        [ngClass]="[sizeClass, shapeClass]" aria-hidden="true">
        {{ (name || '?').substring(0, 2).toUpperCase() }}
      </div>
    </ng-template>
  `
})
export class AgentAvatarComponent implements OnChanges {
  @Input() url: string | null | undefined = null;
  @Input() name = '';
  /** Tailwind size and text classes, e.g. 'w-8 h-8 text-xs'. */
  @Input() sizeClass = 'w-8 h-8 text-xs';
  @Input() shapeClass = 'rounded-full';

  failed = false;

  ngOnChanges(changes: SimpleChanges): void {
    // A new link (refreshed after expiry, or a replaced photo) gets a fresh attempt.
    if (changes['url']) {
      this.failed = false;
    }
  }
}
